/**
* @name: LayoutHeader
* @author: weiyong
* @date: 2022-10-01 08:43
* @description：LayoutBody
* @update: 2022-10-01 08:43
*/
<template>
  <div :class="[prefixCls,getHeaderClass]">
    <!-- left start -->
    <div :class="`${prefixCls}-left`">

      <LayoutTrigger
        :theme="getHeaderTheme"
        :sider="false"
      />

    <SpaceSelItem></SpaceSelItem>

    </div>
    <!-- left end -->

    <div :class="`${prefixCls}-action`">
      <AppSearch :class="`${prefixCls}-action__item `" v-if="getShowSearch" />

      <Notify v-if="getShowNotice" :class="`${prefixCls}-action__item notify-item`" />

      <FullScreen v-if="getShowFullScreen" :class="`${prefixCls}-action__item fullscreen-item`" />


      <AppLocalePicker
        v-if="getShowLocalePicker"
        :reload="true"
        :showText="false"
        :class="`${prefixCls}-action__item`"
      />
      <!--用户菜单下拉-->
      <UserDropDown :theme="getHeaderTheme" />

      <SettingDrawer v-if="getUserDefLayout!==false" :class="`${prefixCls}-action__item`" />

      <UpdateLogIcon :class="`${prefixCls}-action__item`" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: "LayoutHeader"
}
</script>

<script lang="ts" setup>
import {computed,unref} from 'vue';
import {useDesign} from "@/hooks/web/useDesign";
import { AppLocalePicker } from '@/components/Application';
const { prefixCls } = useDesign('layout-header-app');
import { useHeaderSetting } from '@/hooks/setting/useHeaderSetting';
import SpaceSelItem from '../../../default/header/components/SpaceSelItem.vue';
import LayoutTrigger from '../../../default/trigger/index.vue';
//用户下拉
import { UserDropDown ,Notify ,FullScreen, UpdateLogIcon } from '../../../default/header/components';
import { AppSearch } from '@/components/Application';
//本地国际化操作
import {useLocale} from '@/i18n/useLocale';
import { createAsyncComponent } from '@/utils/factory/createAsyncComponent';
import {useRootSetting} from "@/hooks/setting/useRootSetting";


const {
  getShowSearch,
  getShowNotice,
  getShowFullScreen,
  getHeaderTheme,
} = useHeaderSetting();


const { getShowLocalePicker } = useLocale();

const {
  getUserDefLayout,
} = useRootSetting();

const SettingDrawer = createAsyncComponent(() => import('@/layouts/default/setting/index.vue'), {
  loading: true,
});

const getHeaderClass = computed(() => {
  const theme = unref(getHeaderTheme);
  return [
    prefixCls,
    {
      [`${prefixCls}--${theme}`]: theme,
    },
  ];
});
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-layout-header-app';
@header-app:60px;

.@{prefix-cls} {
  height: @header-app;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
  background-color: var(--header-bg-color,#FFF);
  box-shadow: 0 4px 6px 0 rgb(12 31 80 / 4%);

  &.@{prefix-cls}--dark{
      color:#FFF;
    .ant-badge{
      color:#FFF;
    }

    .@{namespace}-layout-header-app-action__item {
      &:hover{
        background-color: @header-dark-bg-hover-color;
      }
    }
  }

  &.@{prefix-cls}--light{
    color:#333;
    .ant-badge{
      color:#333;
    }

    .@{namespace}-layout-header-app-action__item {
      &:hover{
        background-color: @header-light-bg-hover-color;
      }
    }
  }

  .@{namespace}-header-user-dropdown{
    height: @header-app;
  }
  //左侧
  .@{prefix-cls}-left{
    display: flex;

    .@{namespace}-layout-header-trigger{
      font-size: 18px;
      display: flex;
      height:  @header-app;
      padding: 1px 10px 0;
      cursor: pointer;
      align-items: center;
    }
  }

  //右侧
  .@{prefix-cls}-action{
    display: flex;
    min-width: 180px;
    align-items: center;

    .@{namespace}-layout-header-app-action__item {
      display: flex !important;
      height:  @header-app;
      padding: 0 14px;
      font-size: 1.2em;
      cursor: pointer;
      align-items: center;
    }
  }
}
</style>
